import Image from "../common/Image";
import styles from "../../styles/results.module.css";
import { useTranslation } from "react-i18next";
import { IPrimaryDocumentImages } from "../../types/onboard";

const PhotosContainer = ({
  documentFront,
  documentBack,
  primaryDocumentImages
}: {
  documentFront: string | undefined;
  documentBack: string | undefined;
  primaryDocumentImages: IPrimaryDocumentImages
}) => {
  const {t} = useTranslation();
  return (
    <div>
        <div
          className={styles.infoPhotosContainer}
          style={{
            gap: "20px",
          }}
        >
          {(documentFront || primaryDocumentImages?.frontImage != "") && (
            <div className={styles.imageContainer}>
              <div className={styles.verificationContainerHeader}>
                <h2 className={styles.documentTitle}>{t('review.documentimage.front')}</h2>
              </div>
              <div className={styles.imageWrapper}>
                <Image
                  className={documentFront ? styles.documentImg : styles.unrecognizedDocumentImg}
                  src={`data:image/jpeg;base64,${documentFront ? documentFront : primaryDocumentImages?.frontImage}`}
                ></Image>
              </div>
            </div>
          )}
          {(documentBack || primaryDocumentImages?.backImage != "") && (
            <div className={styles.imageContainer}>
              <div className={styles.verificationContainerHeader}>
                <h2 className={styles.documentTitle}>{t('review.documentimage.back')}</h2>
              </div>

              <div className={styles.imageWrapper}>
                <Image
                  className={documentBack ? styles.documentImg : styles.unrecognizedDocumentImg}
                  src={`data:image/jpeg;base64,${documentBack ? documentBack : primaryDocumentImages?.backImage}`}
                ></Image>
              </div>
            </div>
          )}
        </div>
    </div>
  );
};

export default PhotosContainer;
